import { Alert, Col, message, Row, Spin, Table } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, InputItem, InputNumberItem, ModalItem, SegmentedItem, SelectItem, SwitchItem, TagItem, TextAreaItem } from "../../../../Components/Items";
import { colorPaleta } from "../../../../Components/TagItem";
import SelectClientesEmisoraBiwoItem from "../../../../Components/SelectClientesEmisoraBiwoItem";
import { formatoDinero, postCobro } from "../../../PanelPrincipal/EmpresasBiwo/CobroBiwo/cobroBiwoTextos";

const Etiqueta = ({ children }) => <div style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 4 }}>{children}</div>;
const Seccion = ({ titulo, children }) => (
    <div style={{ border: "1px solid #f0f0f0", borderRadius: 8, padding: "10px 14px 14px", marginTop: 12 }}>
        <div style={{ fontWeight: 600, fontSize: 14, color: "#333", paddingBottom: 8, marginBottom: 10, borderBottom: `2px solid ${colorPaleta("cyan")}55` }}>{titulo}</div>
        {children}
    </div>
);

const estadoInicial = (precioHora, vendedorId) => ({
    vendedorId,
    periodicidad: "mensual",
    mesesAnual: 12,
    usuarios: 1,
    empresas: [{ nombre: "", modulos: {} }],
    desarrollo: { horas: 0, precioHora: precioHora || 0, descripcion: "", agrupar: false },
    cliente: { modo: "generico", persona: true },
    resumen: null,
    error: "",
    calculando: false,
    creando: false,
});

class CotizadorPlanBiwo extends Component {
    vendedorDefault = () => ((this.props.vendedores || []).some((v) => String(v._id) === String(this.props.usuarioId)) ? this.props.usuarioId : undefined);

    state = { conceptos: [], ...estadoInicial(this.props.precioHoraDesarrollo, this.vendedorDefault()) };

    componentDidMount() {
        postCobro(axios, "selectConceptosCobro", { soloActivos: true }, this.props.headersToken).then((data) => {
            if (data.success === 2) this.setState({ conceptos: data.data.filter((c) => c.alcance === "empresa") });
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) this.setState(estadoInicial(this.props.precioHoraDesarrollo, this.vendedorDefault()), this.calcular);
    }

    componentWillUnmount() {
        this.calcularDebounced.cancel();
    }

    cuerpo = (preparar = false) => ({
        empresaId: this.props.empresaId,
        periodicidad: this.state.periodicidad,
        mesesAnual: this.state.mesesAnual,
        usuarios: this.state.usuarios,
        empresas: this.state.empresas,
        desarrollo: this.state.desarrollo,
        ...(preparar ? { preparar: true, cliente: this.state.cliente, vendedorId: this.state.vendedorId } : {}),
    });

    calcular = () => {
        this.setState({ calculando: true });
        postCobro(axios, "cotizarPlanBiwo", this.cuerpo(), this.props.headersToken)
            .then((data) => this.setState({ calculando: false, resumen: data.success === 2 ? data.data : null, error: data.success === 2 ? "" : data.message }))
            .catch(() => this.setState({ calculando: false, error: "Error de red al calcular" }));
    };

    calcularDebounced = debounce(this.calcular, 400);

    cambiar = (cambio) => this.setState(cambio, this.calcularDebounced);

    cambiarNumeroEmpresas = (valor) => {
        const n = Math.max(1, Math.min(50, parseInt(valor, 10) || 1));
        const empresas = [...this.state.empresas];
        while (empresas.length < n) empresas.push({ nombre: "", modulos: { ...(empresas[0]?.modulos || {}) } });
        this.cambiar({ empresas: empresas.slice(0, n) });
    };

    cambiarEmpresa = (indice, cambio) => this.cambiar({ empresas: this.state.empresas.map((e, i) => (i === indice ? { ...e, ...cambio } : e)) });

    cambiarModulo = (indice, clave, valor) =>
        this.cambiarEmpresa(indice, { modulos: { ...this.state.empresas[indice].modulos, [clave]: valor || undefined } });

    cambiarCliente = (cambio) => this.setState((s) => ({ cliente: { ...s.cliente, ...cambio } }));

    crear = () => {
        this.setState({ creando: true });
        postCobro(axios, "cotizarPlanBiwo", this.cuerpo(true), this.props.headersToken)
            .then((data) => {
                this.setState({ creando: false });
                if (data.success === 2) this.props.onCotizacionLista(data.data);
                else message.error(data.message || "No se pudo preparar la cotización");
            })
            .catch(() => {
                this.setState({ creando: false });
                message.error("Error de red al preparar la cotización");
            });
    };

    renderMatriz() {
        const { empresas, conceptos } = this.state;
        const columns = [
            { title: "Módulo", dataIndex: "nombre", width: 220, fixed: "left", render: (nombre) => <span style={{ fontWeight: 500 }}>{nombre}</span> },
            ...empresas.map((e, i) => ({
                key: `empresa-${i}`,
                width: 190,
                title: <InputItem placeholder={`Empresa ${i + 1}`} value={e.nombre} onChange={(ev) => this.cambiarEmpresa(i, { nombre: ev.target.value })} />,
                render: (_, c) =>
                    c.tipoPrecio === "niveles" ? (
                        <SelectItem
                            size="small"
                            width="100%"
                            allowClear
                            placeholder="Sin contratar"
                            value={e.modulos[c.clave]}
                            onChange={(nivelId) => this.cambiarModulo(i, c.clave, nivelId)}
                            options={c.niveles.filter((n) => n.activo !== false).map((n) => ({ value: n._id, label: `${n.nombre} · ${formatoDinero(n.precio)}` }))}
                        />
                    ) : (
                        <div style={{ textAlign: "center" }}>
                            <SwitchItem size="small" checked={!!e.modulos[c.clave]} onChange={(activo) => this.cambiarModulo(i, c.clave, activo)} />
                        </div>
                    ),
            })),
        ];
        return (
            <Table
                size="small"
                className="custom-small-table"
                bordered
                pagination={false}
                rowKey="clave"
                columns={columns}
                dataSource={conceptos}
                scroll={{ x: "max-content" }}
                locale={{ emptyText: "Sin módulos" }}
            />
        );
    }

    renderCliente() {
        const { cliente } = this.state;
        return (
            <>
                <SegmentedItem
                    options={[{ label: "Genérico", value: "generico" }, { label: "Cliente existente", value: "existente" }, { label: "Dar de alta", value: "nuevo" }]}
                    value={cliente.modo}
                    onChange={(modo) => this.cambiarCliente({ modo })}
                />
                <div style={{ marginTop: 10 }}>
                    {cliente.modo === "generico" && <TagItem cyan>PÚBLICO EN GENERAL</TagItem>}
                    {cliente.modo === "existente" && (
                        <SelectClientesEmisoraBiwoItem width="100%" value={cliente.clienteId} onChange={(clienteId) => this.cambiarCliente({ clienteId })} />
                    )}
                    {cliente.modo === "nuevo" && (
                        <Row gutter={[10, 10]} align="middle">
                            <Col xs={24} md={6}>
                                <SegmentedItem options={[{ label: "Moral", value: true }, { label: "Física", value: false }]} value={cliente.persona} onChange={(persona) => this.cambiarCliente({ persona })} />
                            </Col>
                            <Col xs={24} md={6}>
                                <InputItem placeholder="RFC" value={cliente.rfc} onChange={(ev) => this.cambiarCliente({ rfc: ev.target.value.toUpperCase() })} />
                            </Col>
                            {cliente.persona ? (
                                <Col xs={24} md={12}>
                                    <InputItem placeholder="Razón social" value={cliente.nombre} onChange={(ev) => this.cambiarCliente({ nombre: ev.target.value })} />
                                </Col>
                            ) : (
                                <>
                                    <Col xs={24} md={4}><InputItem placeholder="Nombre" value={cliente.nombre} onChange={(ev) => this.cambiarCliente({ nombre: ev.target.value })} /></Col>
                                    <Col xs={24} md={4}><InputItem placeholder="Apellido paterno" value={cliente.apellidoPaterno} onChange={(ev) => this.cambiarCliente({ apellidoPaterno: ev.target.value })} /></Col>
                                    <Col xs={24} md={4}><InputItem placeholder="Apellido materno" value={cliente.apellidoMaterno} onChange={(ev) => this.cambiarCliente({ apellidoMaterno: ev.target.value })} /></Col>
                                </>
                            )}
                            <Col xs={24} md={12}>
                                <InputItem placeholder="Correo" value={cliente.correo} onChange={(ev) => this.cambiarCliente({ correo: ev.target.value })} />
                            </Col>
                        </Row>
                    )}
                </div>
            </>
        );
    }

    renderResumen() {
        const { resumen, error } = this.state;
        if (error) return <Alert type="error" showIcon message={error} style={{ borderRadius: 6 }} />;
        if (!resumen) return null;
        const filas = [
            ...resumen.partidas.map((p, i) => ({ key: i, concepto: [p.empresaNombre, p.nombre].filter(Boolean).join(" · "), detalle: p.observaciones, cantidad: p.cantidad, precio: p.precioUnitario, importe: p.importe, combo: p.tipo === "combo" })),
            ...(resumen.desarrollo
                ? [{
                    key: "desarrollo",
                    concepto: "Desarrollo de módulos personalizados",
                    detalle: `${resumen.desarrollo.descripcion} · ${resumen.desarrollo.horas} horas de programación${resumen.desarrollo.agrupar ? ` × ${formatoDinero(resumen.desarrollo.precioHora)}` : ""}`,
                    cantidad: resumen.desarrollo.agrupar ? 1 : resumen.desarrollo.horas,
                    precio: resumen.desarrollo.agrupar ? resumen.desarrollo.importe : resumen.desarrollo.precioHora,
                    importe: resumen.desarrollo.importe,
                }]
                : []),
        ];
        return (
            <Table
                size="small"
                className="custom-small-table"
                pagination={false}
                scroll={{ x: "max-content" }}
                dataSource={filas}
                columns={[
                    { title: "Concepto", render: (f) => <>{f.concepto} {f.combo && <TagItem verdeNatural>Combo</TagItem>}</> },
                    { title: "Detalle", dataIndex: "detalle" },
                    { title: "Cant.", dataIndex: "cantidad", align: "right", width: 70, sorter: (a, b) => a.cantidad - b.cantidad },
                    { title: "Precio (sin IVA)", dataIndex: "precio", render: formatoDinero, align: "right", width: 130, sorter: (a, b) => a.precio - b.precio },
                    { title: "Importe (sin IVA)", dataIndex: "importe", render: formatoDinero, align: "right", width: 130, sorter: (a, b) => a.importe - b.importe },
                ]}
                summary={() => (
                    <Table.Summary.Row>
                        <Table.Summary.Cell colSpan={3}>
                            {resumen.periodicidad === "anual" ? `Anual (${resumen.mesesAnual} meses)` : "Mensual"}
                            {resumen.ahorro > 0 && <TagItem verdeNatural style={{ marginLeft: 8 }}>Ahorra {formatoDinero(resumen.ahorro)}</TagItem>}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell colSpan={2} align="right"><b>{formatoDinero(resumen.total)}</b></Table.Summary.Cell>
                    </Table.Summary.Row>
                )}
            />
        );
    }

    render() {
        const { periodicidad, mesesAnual, usuarios, empresas, desarrollo } = this.state;
        return (
            <ModalItem visible={this.props.visible} title="Cotizar plan BIWO" onCancel={this.props.onCancel} footer={null} spinning={false} width={1100} destroyOnClose>
                <Spin spinning={this.state.creando}>
                    <Seccion titulo="Plan">
                        <Row gutter={[12, 10]}>
                            <Col xs={24} sm={12} md={6}>
                                <Etiqueta>Periodicidad</Etiqueta>
                                <SegmentedItem
                                    options={[{ label: "Mensual", value: "mensual" }, { label: "Anual", value: "anual" }]}
                                    value={periodicidad}
                                    onChange={(valor) => this.cambiar({ periodicidad: valor })}
                                />
                            </Col>
                            {periodicidad === "anual" && (
                                <Col xs={24} sm={12} md={6}>
                                    <Etiqueta>Meses que se cobran al año</Etiqueta>
                                    <InputNumberItem min={1} max={12} precision={0} value={mesesAnual} onChange={(valor) => this.cambiar({ mesesAnual: valor })} />
                                </Col>
                            )}
                            <Col xs={24} sm={12} md={6}>
                                <Etiqueta>Usuarios</Etiqueta>
                                <InputNumberItem min={0} precision={0} value={usuarios} onChange={(valor) => this.cambiar({ usuarios: valor ?? 0 })} />
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <Etiqueta>Empresas</Etiqueta>
                                <InputNumberItem min={1} max={50} precision={0} value={empresas.length} onChange={this.cambiarNumeroEmpresas} />
                            </Col>
                        </Row>
                    </Seccion>
                    <Seccion titulo="Módulos por empresa">{this.renderMatriz()}</Seccion>
                    <Seccion titulo="Desarrollo de módulos personalizados">
                        <Row gutter={[12, 10]}>
                            <Col xs={24} sm={12} md={4}>
                                <Etiqueta>Horas de programación</Etiqueta>
                                <InputNumberItem min={0} placeholder="Horas de programación" value={desarrollo.horas} onChange={(horas) => this.cambiar({ desarrollo: { ...desarrollo, horas: horas ?? 0 } })} />
                            </Col>
                            <Col xs={24} sm={12} md={4}>
                                <Etiqueta>Precio por hora</Etiqueta>
                                <InputNumberItem dinero min={0} placeholder="Precio por hora" value={desarrollo.precioHora} onChange={(precioHora) => this.cambiar({ desarrollo: { ...desarrollo, precioHora: precioHora ?? 0 } })} />
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <Etiqueta>En la cotización</Etiqueta>
                                <SegmentedItem
                                    options={[{ label: "Por hora", value: false }, { label: "Un solo insumo", value: true }]}
                                    value={!!desarrollo.agrupar}
                                    onChange={(agrupar) => this.cambiar({ desarrollo: { ...desarrollo, agrupar } })}
                                />
                            </Col>
                            <Col xs={24} sm={12} md={10}>
                                <Etiqueta>Qué se va a programar</Etiqueta>
                                <TextAreaItem rows={1} placeholder="Qué se va a programar" value={desarrollo.descripcion} onChange={(ev) => this.cambiar({ desarrollo: { ...desarrollo, descripcion: ev.target.value } })} />
                            </Col>
                        </Row>
                    </Seccion>
                    <Seccion titulo="Cliente y vendedor">
                        <Row gutter={[12, 10]}>
                            <Col xs={24} md={16}>
                                <Etiqueta>Cliente</Etiqueta>
                                {this.renderCliente()}
                            </Col>
                            <Col xs={24} md={8}>
                                <Etiqueta>Vendedor</Etiqueta>
                                <SelectItem
                                    width="100%"
                                    showSearch
                                    optionFilterProp="label"
                                    placeholder="Vendedor de la venta"
                                    value={this.state.vendedorId}
                                    onChange={(vendedorId) => this.setState({ vendedorId })}
                                    options={(this.props.vendedores || []).map((v) => ({ value: v._id, label: v.nombre }))}
                                />
                            </Col>
                        </Row>
                    </Seccion>
                    <Seccion titulo="Resumen">
                        <Spin spinning={this.state.calculando}>{this.renderResumen()}</Spin>
                    </Seccion>
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, flexWrap: "wrap", margin: "16px 0 10px" }}>
                        <ButtonItem danger onClick={this.props.onCancel}>Cancelar</ButtonItem>
                        <ButtonItem cyan disabled={!this.state.resumen || !!this.state.error} onClick={this.crear}>Crear cotización</ButtonItem>
                    </div>
                </Spin>
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => ({ headersToken: state.user.headersToken, empresaId: state.empresa.id, usuarioId: state.user.usuarioId });

export default connect(mapStateToProps)(CotizadorPlanBiwo);
